import type { NetworkStatusValue } from '@tunasong/models'
import { createContext } from 'react'

export const NetworkStatusContext = createContext<NetworkStatusValue>({
  status: 'online',
  lastContactMs: null,
  hasEverBeenOnline: false,
})
